const CustomFieldTypesEnum = Object.assign({
  STRING: { name: 'Text', value: 'str' },
  BOOLEAN: { name: 'Flag', value: 'f' },
  DATE: { name: 'Date', value: 'date' },
  FLOAT: { name: 'Kommazahl', value: 'float' },
  INTEGER: { name: 'Ganze Zahl', value: 'int' },
});

Object.freeze(CustomFieldTypesEnum);

function getEnumAsArray() {
  return Object.keys(CustomFieldTypesEnum)
    .map(key => ({
      name: CustomFieldTypesEnum[key].name,
      value: CustomFieldTypesEnum[key].value,
    }));
}

export const customFieldTypesArray = getEnumAsArray();

export default CustomFieldTypesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/CustomFieldTypes.js